import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';
import { UliActivityType } from '../../common/constants/uli';
import { PipesModule } from '../../common/pipes/pipes.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-uli-type',
  imports: [CommonModule, TranslateModule, PipesModule, MatTooltipModule, SvgIconComponent],
  templateUrl: './uli-type.component.html',
  styleUrls: ['./uli-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UliTypeComponent {
  @Input() type: UliActivityType;
  @Input() isLabelHidden = false;
  @Input() highlightOutbounds? = false;

  notAvailable = NOT_AVAILABLE;
  uliActivityType = UliActivityType;
}
